<template>
	<v-dialog v-model="dialog" max-width="620" transition="dialog-transition" content-class="round">
		<v-card class="new_kit py-6 px-4">
			<v-row no-gutters justify="center" v-if="!needChromeExtension">
				<v-col cols="12" class="text-center">
					<h1 class="big">New Experince Flow</h1>
					<h3 class="my-3">
						To create an experience flow that starts with a UI Element,<br />
						Go to the UI Builder and create your element.
					</h3>
					<SIcon class="my-2" name="svg-exp-big" /><br />
					<div style="position: relative; display: inline-block">
						<v-checkbox label="I want my element to appear on a specific page" style="display: inline-block"></v-checkbox><br />
						<v-text-field
							dense
							outlined
							placeholder="Enter URL here"
							class="param_field"
							style="width: 100%; position: relative; display: inline-block"
						></v-text-field>
					</div>
					<br />
					<v-btn class="med_btn my-2" color="primary" height="45">Go to UI Builder</v-btn>
				</v-col>
			</v-row>
			<v-row no-gutters v-else>
				<v-col cols="12" class="text-center">
					<h1 class="big">
						You'll need the Ply chrome Extension<br />
						to create UI Elements
					</h1>
					<SIcon class="mt-10 mb-6" name="svg-need-chrome" /><br />
					<v-btn class="med_btn my-6" color="primary" height="45">Get the Extension </v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'FlowDialogNewFlow',
	props: { newFlowDialog: { type: Boolean } },
	computed: {},
	methods: {},
	watch: {
		newFlowDialog: {
			handler(newV) {
				this.dialog = newV;
			},
			immediate: true,
		},
		dialog: {
			handler(newV) {
				this.$emit('update:newFlowDialog', newV);
			},
		},
	},
	data: () => ({
		dialog: false,
		needChromeExtension: false,
	}),
	mounted() {},
};
</script>

<style scoped>
.med_btn {
	width: 145px;
	border-radius: 3px !important;
}
</style>
